import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  createThemes: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation-themes`,
  },
  getThemes: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation-themes`,
  },
  getOfficialThemes: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation-themes/official`,
  },
  deleteTheme: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/presentation-themes/{themeId}`,
  },
  updatePresentationTheme: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/theme`,
  },
  updateTheme: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/presentation-themes/{themeId}`,
  },
  getTeamThemes: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation-themes/share-by-team`,
  },
  /**
   * Fetches a specific theme by its ID
   * Used for retrieving detailed theme information, typically for theme updates or previews
   */
  getThemeById: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation-themes/{themeId}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const updatePresentationTheme = async (presentationId, params) => {
  const res = await resource.updatePresentationTheme({ presentationId }, params)
  return res.body
}

const createThemes = async (params) => {
  const res = await resource.createThemes(params)
  return res.body
}

const getThemes = async () => {
  const res = await resource.getThemes()
  return res.body
}

const getOfficialThemes = async () => {
  const res = await resource.getOfficialThemes()
  return res.body
}

const deleteTheme = async (themeId) => {
  const res = await resource.deleteTheme({ themeId })
  return res.body
}

const getTeamThemes = async () => {
  const res = await resource.getTeamThemes()
  return res.body
}

const updateTheme = async (themeId, params) => {
  const res = await resource.updateTheme({ themeId }, params)
  return res.body
}

const getThemeById = async (themeId) => {
  const res = await resource.getThemeById({ themeId })
  return res.body
}

export default {
  initResource,
  updatePresentationTheme,
  createThemes,
  getThemes,
  deleteTheme,
  getOfficialThemes,
  updateTheme,
  getTeamThemes,
  getThemeById,
}
